import { Link } from 'react-router-dom';
import Seo from '../../components/Seo/Seo';
import PhoneSupport from '../../components/PhoneSupport/PhoneSupport';
import { SITE_NAME } from '../../data/businessInfo';

/**
 * Catch-all route (path="*"). A static SPA cannot return a real HTTP 404 from
 * React itself, so nginx answers the status: unknown paths outside the site's
 * route families get a 404 and still serve the shell, and this component renders
 * underneath it (see conf.d/akku-24.hu.conf `@spa_notfound`). `noindex` stays as
 * the second signal for anything that slips through as 200 — without it every
 * mistyped URL would be indexable duplicate content. Never prerendered
 * (scripts/prerender.mjs only renders the known route list).
 *
 * The wording covers BOTH "this page is gone" and "something went wrong", because
 * the visitor cannot tell which happened — the same contract as akkusegely.hu's
 * template/error404.tpl, which every 404 in the estate now mirrors.
 *
 * The call-centre CTA is the site's own <PhoneSupport> button, so the reveal fires
 * exactly the analytics the header does: notifyPhoneShow() (GA4 Phone_Show + the
 * first-party /phone_show beacon that stamps phone_show_datetime for the admin's
 * call-source attribution) and notifyPhoneCall() on the dial.
 */
export default function NotFoundPage() {
	return (
		<div className="container article" style={{ textAlign: 'center', padding: '40px 0 60px' }}>
			<Seo title={`Hiba történt – az oldal nem érhető el - ${SITE_NAME}`} noindex />

			<h1>Hiba történt – az oldal nem érhető el</h1>

			<p style={{ marginTop: 14, maxWidth: 620, marginLeft: 'auto', marginRight: 'auto' }}>
				Vagy elírás történt a címben, vagy az oldal időközben megszűnt, esetleg rendszerhiba
				lépett fel. Elnézést kérünk a kellemetlenségért!
			</p>

			<p style={{ marginTop: 10, maxWidth: 620, marginLeft: 'auto', marginRight: 'auto' }}>
				Ha akkumulátorral kapcsolatban van szüksége segítségre, ügyfélszolgálatunk{' '}
				<strong>minden nap 8 és 24 óra között</strong> hívható – hívjon minket bizalommal.
			</p>

			<div style={{ margin: '28px 0 22px', display: 'flex', justifyContent: 'center' }}>
				<PhoneSupport />
			</div>

			<p style={{ marginTop: 26 }}>
				Vagy böngésszen tovább: <Link to="/">főoldal</Link>
				{' · '}<Link to="/arlista">árlista</Link>
				{' · '}<Link to="/akkuvalaszto">akkuválasztó</Link>
				{' · '}<Link to="/blog">blog</Link>
			</p>
		</div>
	);
}
